export const SnackbarDuration = 6000;
export const ButToLetDecimalAmountEnabled = false;
export const NewsImageQuality = 93;
